(function () {
 'use strict';
 if (customElements.get('leha-carousel')) return;
 customElements.define('leha-carousel', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.clearRotation(); this.cancelAnimation();
   this.controller = new AbortController();
   const signal = this.controller.signal;
   this.track = this.querySelector('[data-leha-carousel-track]');
   if (!this.track) return;
   this.cards = Array.from(this.track.children);
   this.controls = this.querySelector('[data-leha-carousel-controls]');
   this.toggle = this.querySelector('[data-leha-carousel-toggle]');
   this.motion = matchMedia('(prefers-reduced-motion: reduce)');
   this.rtl = getComputedStyle(this).direction === 'rtl';
   this.autoplay = this.dataset.autoplay === 'true' && !this.classList.contains('leha-carousel--video');
   this.interval = Math.max(5, Math.min(15, Number(this.dataset.interval) || 5)) * 1000;
   this.userPaused = false; this.hovered = false; this.gesture = null; this.resumeAt = 0;
   this.pageHidden = false;
   this.visible = !window.IntersectionObserver && this.inViewport();
   this.dataset.count = String(this.cards.length);
   const dots = this.querySelector('[data-leha-carousel-dots]');
   dots?.replaceChildren();
   this.cards.forEach((card, index) => {
    if (!dots) return;
    const button = document.createElement('button');
    button.type = 'button'; button.dataset.lehaCarouselIndex = String(index);
    button.setAttribute('aria-label', this.itemLabel(index));
    button.setAttribute('aria-controls', this.track.id);
    button.append(document.createElement('span')); button.firstChild.setAttribute('aria-hidden', 'true'); dots.append(button);
   });
   this.addEventListener('click', event => {
    const step = event.target.closest('[data-leha-carousel-step]');
    const dot = event.target.closest('[data-leha-carousel-index]');
    if (step && !step.disabled && this.contains(step)) this.move(this.current + Number(step.dataset.lehaCarouselStep), true);
    if (dot && this.contains(dot)) this.move(Number(dot.dataset.lehaCarouselIndex), true);
    if (event.target.closest('[data-leha-carousel-toggle]') === this.toggle && this.toggle) {
     this.userPaused = !this.userPaused; this.clearRotation(); this.cancelAnimation(); this.updateToggle(); this.queueRotation();
    }
    const launch = event.target.closest('[data-leha-video-launch]');
    if (launch && this.contains(launch)) this.launchVideo(launch);
   }, {signal});
   this.track.addEventListener('keydown', event => {
    if (event.target !== this.track) return;
    let index;
    if (event.key === 'ArrowLeft') index = this.current + (this.rtl ? 1 : -1);
    if (event.key === 'ArrowRight') index = this.current + (this.rtl ? -1 : 1);
    if (event.key === 'Home') index = 0;
    if (event.key === 'End') index = this.cards.length - 1;
    if (index !== undefined) { event.preventDefault(); this.move(index, true); }
   }, {signal});
   this.addEventListener('focusin', () => { this.clearRotation(); this.cancelAnimation(); }, {signal});
   this.addEventListener('focusout', () => {
    clearTimeout(this.focusTimer);
    this.focusTimer = setTimeout(() => { this.focusTimer = null; this.queueRotation(); }, 0);
   }, {signal});
   this.track.addEventListener('focusin', event => {
    const card = this.cards.find(item => item.contains(event.target));
    if (!card) return;
    const bounds = this.track.getBoundingClientRect(), rect = card.getBoundingClientRect();
    if (rect.left < bounds.left || rect.right > bounds.right) this.move(this.cards.indexOf(card), false);
   }, {signal});
   this.addEventListener('pointerenter', event => {
    if (event.pointerType === 'mouse' || !event.pointerType) { this.hovered = true; this.clearRotation(); this.cancelAnimation(); }
   }, {signal});
   this.addEventListener('pointerleave', event => {
    if (event.pointerType === 'mouse' || !event.pointerType) { this.hovered = false; this.queueRotation(); }
   }, {signal});
   this.track.addEventListener('pointerdown', event => {
    this.interact(10000); this.gesture = {x:event.clientX,y:event.clientY,id:event.pointerId};
   }, {passive:true,signal});
   this.track.addEventListener('pointermove', event => {
    const g = this.gesture;
    if (g && event.pointerId === g.id && Math.abs(event.clientX-g.x) > 8 && Math.abs(event.clientX-g.x) > Math.abs(event.clientY-g.y)) {
     g.swiped = true; this.suppressUntil = Date.now()+700;
    }
   }, {passive:true,signal});
   const finish = event => {
    if (!this.gesture || this.gesture.id !== event.pointerId) return;
    if (this.gesture.swiped) this.suppressUntil = Date.now()+700;
    this.gesture = null; this.resumeAt = Date.now()+10000; this.queueRotation();
   };
   document.addEventListener('pointerup', finish, {passive:true,signal});
   document.addEventListener('pointercancel', finish, {passive:true,signal});
   this.track.addEventListener('wheel', () => { this.interact(10000); this.queueRotation(); }, {passive:true,signal});
   this.track.addEventListener('click', event => {
    if (event.detail && Date.now() < (this.suppressUntil || 0) && event.target.closest('a,button,input[type="submit"]')) { event.preventDefault(); event.stopImmediatePropagation(); }
   }, {capture:true,signal});
   this.track.addEventListener('scroll', () => {
    this.schedule();
    if (!this.animation) {
     this.clearRotation(); clearTimeout(this.settleTimer);
     this.settleTimer = setTimeout(() => this.settled(), 180);
    }
   }, {passive:true,signal});
   this.track.addEventListener('scrollend', () => { if (!this.animation) this.settled(); }, {signal});
   this.track.addEventListener('play', event => {
    if (!(event.target instanceof HTMLVideoElement)) return;
    document.querySelectorAll('leha-carousel video').forEach(video => { if (video !== event.target) video.pause(); });
    this.pauseOutside();
   }, {capture:true,signal});
   document.addEventListener('visibilitychange', () => {
    this.clearRotation(); this.cancelAnimation(); if (document.hidden) this.pauseAll(); else this.queueRotation();
   }, {signal});
   window.addEventListener('pagehide', () => { this.pageHidden = true; this.clearRotation(); this.cancelAnimation(); this.pauseAll(); }, {signal});
   window.addEventListener('pageshow', () => { this.pageHidden = false; this.queueRotation(); }, {signal});
   this.motion.addEventListener?.('change', () => { this.clearRotation(); this.cancelAnimation(); this.update(); this.queueRotation(); }, {signal});
   document.addEventListener('shopify:block:select', event => {
    const card = this.cards.find(item => item === event.target || item.contains(event.target));
    if (card) this.move(this.cards.indexOf(card), false);
   }, {signal});
   document.addEventListener('shopify:section:unload', event => { if (event.target.contains(this)) this.disconnectedCallback(); }, {signal});
   if (window.ResizeObserver) {
    this.observer = new ResizeObserver(() => {
     this.clearRotation(); this.cancelAnimation(); this.schedule(); clearTimeout(this.settleTimer);
     this.settleTimer = setTimeout(() => { this.move(this.current, false); }, 180);
    }); this.observer.observe(this.track);
   }
   if (window.IntersectionObserver) {
    this.visibilityObserver = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting || entry.intersectionRatio < .5) entry.target.querySelectorAll('video').forEach(video => video.pause()); }), {threshold:[0,.5]});
    this.cards.forEach(card => this.visibilityObserver.observe(card));
    this.rotationObserver = new IntersectionObserver(entries => {
     this.visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .25);
     if (!this.visible) { this.clearRotation(); this.cancelAnimation(); } else this.queueRotation();
    }, {threshold:[0,.25]}); this.rotationObserver.observe(this.track);
   } else window.addEventListener('scroll', () => {
    this.pauseOutside(); this.visible = this.inViewport(); if (!this.visible) { this.clearRotation(); this.cancelAnimation(); } else this.queueRotation();
   }, {passive:true,signal});
   this.current = 0; this.move(0, false, true); this.update(); this.queueRotation();
   this.querySelectorAll('[data-leha-video-launch]').forEach(button => button.disabled = false);
  }
  itemLabel(index) { return this.dataset.itemLabel.replace('__index__', index + 1).replace('__total__', this.cards.length); }
  inViewport() { const b = this.track.getBoundingClientRect(); return b.bottom > 0 && b.top < window.innerHeight; }
  clearRotation() { clearTimeout(this.rotationTimer); this.rotationTimer = null; }
  canRotate() {
   return this.autoplay && this.overflow && this.visible && !document.hidden && !this.pageHidden && !this.motion.matches && !this.userPaused && !this.hovered && !this.gesture && !this.contains(document.activeElement) && !this.animation && !this.controller.signal.aborted;
  }
  queueRotation() {
   this.clearRotation();
   if (!this.canRotate()) return;
   this.rotationTimer = setTimeout(() => {
    this.rotationTimer = null; if (!this.canRotate()) return;
    const geometry = this.geometry(), stops = [0];
    for (const card of this.cards.slice(1)) {
     const position = Math.min(geometry.limit, Math.abs(card.getBoundingClientRect()[geometry.edge] - this.cards[0].getBoundingClientRect()[geometry.edge]));
     if (position > stops.at(-1)+2) stops.push(position);
    }
    let closest = 0;
    stops.forEach((position,index) => { if (Math.abs(position-geometry.position) < Math.abs(stops[closest]-geometry.position)) closest=index; });
    if (closest === stops.length-1) this.animate(0, true);
    else this.animate(stops[closest+1], false);
   }, Math.max(this.interval, this.resumeAt-Date.now()));
  }
  updateToggle() {
   if (!this.toggle) return;
   this.toggle.hidden = !this.autoplay || !this.overflow || this.motion.matches;
   this.toggle.textContent = this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
   this.toggle.setAttribute('aria-pressed', String(this.userPaused));
  }
  interact(delay) { this.clearRotation(); this.cancelAnimation(); this.resumeAt = Date.now()+delay; }
  settled() {
   clearTimeout(this.settleTimer); this.settleTimer = null;
   if (this.controller.signal.aborted) return;
   this.update(); this.queueRotation();
  }
  schedule() {
   if (this.frame || this.controller.signal.aborted) return;
   this.frame = requestAnimationFrame(() => { this.frame = null; if (!this.controller.signal.aborted) this.update(); });
  }
  geometry() {
   const bounds = this.track.getBoundingClientRect(), edge = this.rtl ? 'right' : 'left';
   const style = getComputedStyle(this.track);
   const padding = parseFloat(this.rtl ? style.paddingRight : style.paddingLeft) || 0;
   const start = bounds[edge] + (this.rtl ? -padding : padding);
   return {edge,start,limit:Math.max(0,this.track.scrollWidth-this.track.clientWidth),position:this.cards.length ? Math.max(0,(this.rtl ? 1 : -1)*(this.cards[0].getBoundingClientRect()[edge]-start)) : 0};
  }
  update() {
   const g = this.geometry(); let distance = Infinity;
   this.cards.forEach((card,index) => { const d = Math.abs(card.getBoundingClientRect()[g.edge]-g.start); if (d < distance) { distance=d; this.current=index; } });
   this.overflow = this.cards.length > 1 && g.limit > 2;
   if (this.controls) this.controls.hidden = !this.overflow;
   const previous = this.querySelector('[data-leha-carousel-step="-1"]'), next = this.querySelector('[data-leha-carousel-step="1"]');
   if (previous) previous.disabled = !this.overflow || g.position <= 2;
   if (next) next.disabled = !this.overflow || g.position >= g.limit-2;
   this.querySelectorAll('[data-leha-carousel-index]').forEach(dot => dot.setAttribute('aria-current', String(Number(dot.dataset.lehaCarouselIndex) === this.current)));
   this.updateToggle(); this.pauseOutside();
   const progress = this.querySelector('[data-leha-carousel-progress]');
   if (progress) {
    const fraction = g.limit ? Math.min(1,Math.max(0,g.position/g.limit)) : 0;
    const size = Math.min(1,this.track.clientWidth/Math.max(1,this.track.scrollWidth));
    progress.style.setProperty('--leha-progress-size', `${size*100}%`);
    progress.style.setProperty('--leha-progress-offset', `${fraction*(1-size)*100}%`);
    progress.setAttribute('aria-valuenow', String(Math.round(fraction*100)));
    progress.setAttribute('aria-valuetext', this.itemLabel(this.current));
   }
  }
  move(index, announce, instant = false) {
   index = Math.max(0,Math.min(this.cards.length-1,index));
   if (!this.cards[index]) return;
   this.clearRotation(); this.cancelAnimation();
   if (announce) this.resumeAt = Date.now()+10000;
   const g = this.geometry();
   const position = Math.min(g.limit, Math.abs(this.cards[index].getBoundingClientRect()[g.edge] - this.cards[0].getBoundingClientRect()[g.edge]));
   this.track.scrollBy({left:(this.rtl ? -1 : 1)*(position-g.position),behavior:instant || this.motion.matches ? 'auto' : 'smooth'});
   this.current = index;
   if (announce) this.querySelector('[data-leha-carousel-status]').textContent = this.itemLabel(index);
   this.schedule(); clearTimeout(this.settleTimer); this.settleTimer = setTimeout(() => this.settled(), 180);
  }
  animate(position, wrap) {
   this.clearRotation(); clearTimeout(this.settleTimer); this.settleTimer=null;
   const track=this.track, start=this.geometry().position, began=performance.now(), duration=wrap?400:640;
   this.animation={snap:track.style.scrollSnapType,behavior:track.style.scrollBehavior,opacity:track.style.opacity};
   track.style.scrollSnapType='none'; track.style.scrollBehavior='auto';
   const tick = now => {
    if (!this.animation || this.controller.signal.aborted) return;
    const progress=Math.min(1,(now-began)/duration);
    if (wrap) {
     track.style.opacity=String(progress<.5 ? 1-progress*2 : (progress-.5)*2);
     if (progress>=.5 && !this.animation.reset) {
      this.animation.reset=true; const g=this.geometry(); track.scrollBy({left:(this.rtl ? -1 : 1)*(position-g.position),behavior:'auto'});
     }
    } else {
     const eased=progress<.5?4*progress**3:1-(-2*progress+2)**3/2;
     const g=this.geometry(); track.scrollBy({left:(this.rtl ? -1 : 1)*(start+(position-start)*eased-g.position),behavior:'auto'});
    }
    if (progress<1) this.animationFrame=requestAnimationFrame(tick);
    else { this.cancelAnimation(); this.update(); this.queueRotation(); }
   };
   this.animationFrame=requestAnimationFrame(tick);
  }
  cancelAnimation() {
   if (this.animationFrame) cancelAnimationFrame(this.animationFrame); this.animationFrame=null;
   if (this.animation && this.track) {
    this.track.style.scrollSnapType=this.animation.snap; this.track.style.scrollBehavior=this.animation.behavior; this.track.style.opacity=this.animation.opacity;
   }
   this.animation=null;
  }
  launchVideo(button) {
   const media = button.closest('[data-leha-video-media]');
   const template = media.querySelector('template');
   if (!template || media.querySelector('video')) return;
   const fragment = template.content.cloneNode(true);
   const video = fragment.querySelector('video');
   if (!video) return;
   const signal = this.controller.signal;
   video.controls = true; video.preload = 'none'; video.autoplay = false;
   media.prepend(fragment); button.hidden = true; media.querySelector('[data-leha-video-poster]')?.setAttribute('hidden','');
   video.addEventListener('error', () => { const error = media.querySelector('[data-leha-video-error]'); if (error) error.hidden = false; }, {signal});
   video.focus({preventScroll:true});
   const playback = video.play();
   playback?.catch(reason => {
    if (signal.aborted || (reason?.name === 'AbortError' && (video.paused || document.hidden))) return;
    const error = media.querySelector('[data-leha-video-error]'); if (error) error.hidden = false;
   });
  }
  pauseOutside() {
   const bounds = this.track.getBoundingClientRect();
   this.cards.forEach(card => {
    const rect = card.getBoundingClientRect();
    const overlap = Math.max(0,Math.min(rect.right,bounds.right,window.innerWidth)-Math.max(rect.left,bounds.left,0));
    if (overlap < rect.width*.5 || rect.bottom <= 0 || rect.top >= window.innerHeight || document.hidden) card.querySelectorAll('video').forEach(video => { if (!video.paused) video.pause(); });
   });
  }
  pauseAll() { this.querySelectorAll('video').forEach(video => video.pause()); }
  disconnectedCallback() {
   this.clearRotation(); this.cancelAnimation(); clearTimeout(this.settleTimer); clearTimeout(this.focusTimer);
   this.settleTimer=null; this.focusTimer=null;
   this.pauseAll(); this.controller?.abort(); this.observer?.disconnect(); this.visibilityObserver?.disconnect(); this.rotationObserver?.disconnect();
   if (this.frame) cancelAnimationFrame(this.frame); this.frame=null;
   this.querySelectorAll('video').forEach(video => { video.removeAttribute('src'); video.querySelectorAll('source').forEach(source=>source.removeAttribute('src')); video.load(); video.remove(); });
   this.querySelectorAll('[data-leha-video-launch],[data-leha-video-poster]').forEach(element=>element.hidden=false);
   this.querySelectorAll('[data-leha-video-launch]').forEach(button => button.disabled = true);
   this.querySelectorAll('[data-leha-video-error]').forEach(element => element.hidden = true);
  }
 });
})();
